import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaExclamationTriangle } from 'react-icons/fa';

function Error() {
  const navigate = useNavigate();

  return (
    <Container className="text-center" style={{ marginTop: '5%', color: '#555' }}>
      <Row>
        <Col>
          <FaExclamationTriangle style={{ fontSize: '8rem', color: '#f0ad4e', marginBottom: '20px' }} />
          <h1 style={{ fontSize: '6rem', fontWeight: 'bold' }}>Oops!</h1>
          <p style={{ fontSize: '1.5rem', margin: '20px 0' }}>
            The page you're looking for does not exist.
          </p>
          <p style={{ fontSize: '1.2rem', marginBottom: '30px' }}>
            Try refreshing the page or head over to our live streams to find something interesting.
          </p>
          <Button 
            variant="primary" 
            size="lg" 
            onClick={() => navigate('/live-streams')}
            style={{ padding: '10px 20px', fontSize: '1.2rem' }}
          >
            Go to Live Streams
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default Error;